"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { useSession } from "next-auth/react";
import { ScaffopsButton } from "./ScaffopsMarketingShell";

const NAV = [
  { label: "Platform", hash: "#platform" },
  { label: "Features", hash: "#features" },
  { label: "Time savings", hash: "#problems" },
  { label: "Pricing", href: "/pricing" },
  { label: "Blog", href: "/news" },
  { label: "Switch", href: "/switch" },
] as const;

export function ScaffopsMarketingHeader() {
  const { data: session, status } = useSession();
  const pathname = usePathname() ?? "/";
  const onHome = pathname === "/" || pathname === "";

  return (
    <header className="sticky top-0 z-50">
      <div className="bg-[var(--sm-yellow)] px-4 py-1.5">
        <p className="sm-mono mx-auto max-w-[1200px] text-center text-[10px] font-medium text-[var(--sm-charcoal)] sm:text-[11px]">
          Built by Software Pro&apos;s. With scaffolders. // Jobs • Quotes • Crews • Compliance
        </p>
      </div>
      <div className="border-b border-[var(--sm-grid)] bg-transparent px-4 py-3 backdrop-blur-[2px]">
        <div className="sm-container flex items-center justify-between gap-4">
          <Link href="/" className="sm-display text-xl text-[var(--sm-charcoal)] sm:text-2xl">
            ScaffOps™
          </Link>
          <nav className="hidden items-center gap-6 lg:flex" aria-label="Primary">
            {NAV.map((item) => {
              const href =
                "href" in item
                  ? item.href
                  : onHome
                    ? item.hash
                    : `/${item.hash}`;
              const active = "href" in item && pathname.startsWith(item.href);
              return (
                <Link
                  key={"href" in item ? item.href : item.hash}
                  href={href}
                  className={`text-sm font-medium text-[var(--sm-charcoal)] hover:underline ${
                    active ? "underline" : ""
                  }`}
                >
                  {item.label}
                </Link>
              );
            })}
          </nav>
          {/* Fixed min width stops auth-state swap from shifting the hero (CLS). */}
          <div className="flex min-h-[44px] min-w-[11.5rem] shrink-0 items-center justify-end gap-2 sm:min-w-[18.5rem]">
            {status === "loading" ? (
              <span
                className="inline-block h-11 w-36 animate-pulse bg-[var(--sm-grid)] sm:w-44"
                aria-hidden
              />
            ) : session?.user ? (
              <ScaffopsButton href="/app/enter" variant="primary">
                Open workspace →
              </ScaffopsButton>
            ) : (
              <>
                <ScaffopsButton href="/login" variant="secondary">
                  Log in
                </ScaffopsButton>
                <ScaffopsButton href="/signup" variant="primary">
                  Start free trial →
                </ScaffopsButton>
              </>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}
